module.exports = __webpack_public_path__ + "media/images/profile/check-icon-cf429d75afdb3e51de2f0067622255d5.svg";